import { NgModule } from '@angular/core';
import { EquipmentService } from './services';

@NgModule({
  providers: [EquipmentService]
})
export class DomainEquipmentModule {}